<template>
    <div>
        <vForm ref="freezeform" class="clearfix">
            <vFormItem label-width="100" :label="$t('fbb.bill.account_org', { defaultValue: '账户组织' })" :rules="required" prop="organizationId">
                <vSelect v-model="formData.organizationId" filterable clearable>
                    <vOption v-for="item in getNextOrgList" :key="item.value" :value="item.value">{{item.label}}</vOption>
                </vSelect>
            </vFormItem>
            <vFormItem label-width="100" :label="$t('fbb.bill.freeze_close', { defaultValue: '冻结' })+$t('erp.b2c.money', { defaultValue: '金额' })" :rules="required" prop="amount">
                <vInputNumber v-model="formData.amount" :min="0" style="width:90%;float:left" class="margin-right-10"></vInputNumber> USD
            </vFormItem>
            <vFormItem label-width="100" :label="$t('fbb.bill.freeze_close', { defaultValue: '冻结' })+$t('global.common.reason', { defaultValue: '原因' })">
                <vTextarea v-model="formData.cause"></vTextarea>
            </vFormItem>
        </vForm>
        <footer class="text-right">
            <vButton theme="primary" @click="submit">{{$t('global.common.update_OK', { defaultValue: '确定' })}}</vButton>
            <vButton class="margin-left-10" @click="close">{{$t('global.common.operation_cancel', { defaultValue: '取消' })}}</vButton>
        </footer>
        <vLoading size="large" transfer :loading="loading"></vLoading>
    </div>
</template>
<script>
import { HttpSaveFreeze } from '@/service/recharge';
import { mapGetters } from 'vuex';
export default {
	components: {
		compFormEdit: () => import('@components/templates/formedit'),
	},
	data() {
		return {
			loading: false,
			formData: {
                organizationId:'',
                amount:0,
                cause:'',
            },
            required: [{
                required: true,
                message: this.$t('global.common.required', { defaultValue: '该信息不能为空,请填写' })
            }],
		};
	},
	computed: {
        ...mapGetters('dictionary', ['getNextOrgList']),
	},
	methods: {
        close(){
            this.$emit('on-close')
        },
        async submit(){
            const valid = await this.$refs['freezeform'].validate();
			// console.log(!valid)
            if (!valid) return;
            this.formData.organizationName = this.getNextOrgList.filter(item=> { return item.value == this.formData.organizationId})[0].label;
            this.loading = true
            HttpSaveFreeze(this.formData).then(res=>{
                this.$VMessage.success(res.message);
                this.close()
                this.$emit('on-update')
            },err=>{
                this.$VMessage.error(err.message);
            }).finally(result => {
                this.loading = false;
            })
        }
	}
};
</script>
